export const tankType = {
    unknown: 0,
    cargo: 1,
    waterBallast: 2,
    heavyFuelOil: 3,
    dieselOil: 4,
    lubOil: 5,
    freshWater: 6,
    technicalFreshWater: 7,
    miscellaneousTanks: 8,
    lightFuelOil: 9,
    virtualHfo: 10,
    virtualMgo: 11,
};

export const fuelTypeEnum = {
    hfo: 0,
    mgo: 1,
};

export const inputDataTypeEnum = {
    string: 1,
    datetime: 2,
    int: 3,
    decimal: 4,
    rating: 5,
    dropdown: 6,
    checkbox: 7,
};

export const eventTypeInput = {
    norTenderCargo: 1,
    bunkerHoseOnGrade: 59,
    reTenderNorCargo: 233,
    bunkerHoseOnAtBerthGrade: 261,
    simpleCargoOnboardAtArrival: 271,
    simpleCargoOnboardAtDeparture: 272,
    debunkerHoseOnGrade: 273,
    debunkerReason: 274,
};

export const fuelRobDataTypeEnum = {
    unknown: 0,
    estimationAtNoon: 1,
    measureAtEosp: 2,
    measureAfterBunkering: 3,
};

export const cargoOperationType = {
    loading: 0,
    unloading: 1,
};

export const noonReportType = {
    sea: 1,
    port: 2,
    arrival: 4,
    departure: 5,
};

export const eventType = {
    eosp: 1,
    arrived: 2,
    sosp: 3,
    norTender: 4,
    pumpingCommence: 45,
    pumpingComplete: 46,
    pumpingStopped: 49,
    pumpingResumed: 50,
    wellAnchored: 6,
    anchorAweigh: 8,

    allFast: 18,
    allClear: 21,
    wellAnchoredCargoOps: 10,
    anchorAweighCargoOps: 12,
    wellAnchoredNoCargo: 179,
    anchorAweighNoCargo: 181,

    transshipmentVesselAlongside: 30,
    tankInspectionCommenced: 32,

    tankCleaningCommenced: 13,
    tankCleaningCompleted: 14,

    bunkerBargeAlongside: 61,
    bunkerHoseOn: 79,
    bunkeringCompleted: 81,

    cargoHoseOn: 99,
    cargoHoseOff: 100,

    cargoDelayStart: 131,
    cargoDelayStop: 132,
    berthDelayWithProtestStart: 133,
    berthDelayWithProtestStop: 134,

    steamingForTankCleaningCommenced: 135,
    steamingForTankCleaningCompleted: 136,
    dryDockingCommenced: 137,
    dryDockingCompleted: 138,
    portQuestionnaire: 139,
    tankInspectionCompleted: 140,

    operationalTargetConsumption: 141,
    operationalTargetSpeed: 142,
    operationalChangeToTargetConsumption: 143,
    operationalChangeToTargetSpeed: 144,
    operationalNonTargetVoyage: 145,
    operationalChangeToNonTargetVoyage: 146,
    operationalIdlCrossing: 147,
    operationalAdjustHoursAfterTimeZoneChange: 148,
    operationalStartTankPreparation: 149,
    operationalStopTankPreparation: 150,
    operationalStartAwaitingOrdersOrDrifting: 151,
    operationalStopAwaitingOrdersOrDrifting: 152,

    navigationalStartTrafficManeuvering: 153,
    navigationalStopTrafficManeuvering: 154,
    navigationalStartSafetyManeuvering: 155,
    navigationalStopSafetyManeuvering: 156,
    navigationalStartStormSheltering: 157,
    navigationalStopStormSheltering: 158,
    navigationalStartCasualtyAndSar: 159,
    navigationalStopCasualtyAndSar: 160,
    navigationalStartHighRiskArea: 161,
    navigationalStopHighRiskArea: 162,
    navigationalStartPilotManeuvering: 163,
    navigationalStopPilotManeuvering: 164,
    navigationalStartRiverPortManeuvering: 165,
    navigationalStopRiverPortManeuvering: 166,
    navigationalEnteringEcaZone: 175,
    navigationalLeavingEcaZone: 176,
    navigationalStartCasualtyAndSarDrill: 206,
    navigationalStopCasualtyAndSarDrill: 207,

    technicalStartPropulsionSystemFailure: 167,
    technicalStopPropulsionSystemFailure: 168,
    technicalStartAuxiliarySystemFailure: 169,
    technicalStopAuxiliarySystemFailure: 170,
    technicalStartFuelQualityIssue: 171,
    technicalStopFuelQualityIssue: 172,
    technicalStartOtherTechnicalIssue: 173,
    technicalStopOtherTechnicalIssue: 174,
    dryDockingBerthCommenced: 182,
    dryDockingBerthCompleted: 183,

    bunkerBargeAlongsideAtBerth: 184,
    bunkerBargeCastedOffAtBerth: 185,
    bunkerHoseOnAtBerth: 186,
    bunkeringCompletedAtBerth: 188,

    freePratique: 120,
    reTenderNor: 177,

    simpleBerthArrival: 195,
    simpleBerthDeparture: 196,
    slopHoseOn: 198,
    slopHoseOff: 199,
    preWashCommenced: 200,
    preWashCompleted: 201,
    debunkerHoseOn: 202,
    debunkeringCommenced: 203,
    debunkeringCompleted: 204,
    debunkerHoseOff: 205,
};
